import React from "react";

class Contact extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            toonName: "",
            toonSpecies: "",
            email: "",
            message: "",
            response: "",
            sent: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        var template_params = {
            from_name: this.state.toonName,
            reply_to: this.state.email,
            to_name: process.env.REACT_APP_EMAIL_ADDRESS,
            message_html: this.state.message,
        };

        var service_id = process.env.REACT_APP_EMAIL_SERVICE_ID;
        var template_id = process.env.REACT_APP_EMAIL_TEMPLATE_ID;
        window.emailjs
            .send(service_id, template_id, template_params)
            .then(
                alert(
                    "Email sent successfully! Thank you, Spike will get back to you soon!"
                ),
                this.props.history.push("/")
            );
    }

    render() {
        return (
            <div className="panel">
                <div className="panel-content">
                    <h1>Contact Spike</h1>
                    <p>
                        Have a burning question about Toontown? Do you think
                        something on the site needs to be improved? Have a
                        suggestion? Feel free to shoot Spike an email.
                    </p>
                    <a href="mailto:spikes.rewritten.guide@gmail.com">
                        <button>Contact Spike</button>
                    </a>
                    <hr />
                    <h2>Looking for Toontown Game Support?</h2>
                    <p>
                        While this guide may be able to help answer your game
                        play questions, it cannot help you with technical
                        issues. If you are experiencing some game specific
                        problems, reach out to Toontown Rewritten Support.
                    </p>
                    <a href="mailto:support@toontownrewritten.com">
                        <button>TTR Support</button>
                    </a>
                </div>
            </div>
        );
    }
}

export default Contact;
